export type TemplateSiteRef = {
  delivery_config?: { siteId?: string | null } | null;
};

/**
 * A saved template belongs to a website only when delivery_config.siteId matches.
 * Templates with no site association are hidden once a website is selected.
 */
export function templateBelongsToSite(template: TemplateSiteRef, siteId: string): boolean {
  const selected = siteId.trim();
  if (!selected) return false;
  const templateSiteId = template.delivery_config?.siteId?.trim();
  if (!templateSiteId) return false;
  return templateSiteId === selected;
}

export function filterTemplatesForSite<T extends TemplateSiteRef>(
  templates: T[],
  siteId: string
): T[] {
  return templates.filter((template) => templateBelongsToSite(template, siteId));
}
